 
import React, { useEffect, useState } from 'react';
 
import BizCompanyPro from './BizProPages/BizCompanyPro';
import BizCourtBook from './BizProPages/BizCourtBook';
import BizManageCourt from './BizProPages/BizManageCourt';
import BizNotifi from './BizProPages/BizNotifi';
import BizPaymentHis from './BizProPages/BizPaymentHis';
import searchvec from '../assets/sub.svg'

const BizProfile = () => {
  const [companypro , setCompanypro] = useState( true)  
  const [courtbook , setCourtbook] = useState( false)  
  const [managecourt , setManagecourt] = useState( false)  
  const [payment , setPayment] = useState( false)  
  const [notifi , setNotifi] = useState( false)  
  
  return (
    <>  
    <div className='mb-24'>
        <div className='md:mt-6 mt-3   container mx-auto'>
          {/* serach bar */}
    
      
          <div className='flex border w-[95%] mx-auto border-gray-200 rounded-full'>
          <img src={searchvec} alt='imgg' className=' ml-3 mt-3 h-[25px] w-[35px]'  />
        <input className='w-full ml-3 h-12 bg-[#FBFEFF] rounded-full pl-3 outline-none reltive md:text-sm font-semibold text-xs ' type='text' placeholder='Search your courts' />
        <div className='cursor-pointer bg-blue-100 h-12 w-16 pt-2 rounded-r-full -ml-16'>
        <i class="fa-solid fa-location-crosshairs text-blue-600 ml-4 text-2xl"></i>
   
        </div> 
        </div>

        {/* account pic password and number */}

      

               {/* My booking in account */}

            <div className='main md:w-[88%] mt-5 mx-auto'> 
            <div className='account-wrap    md:flex'>



            <div className='md:w-[20%] w-[50%] mx-3 '> 
            <div className=' '>
            <h1 className='text-2xl text-[#272C34] font-bold'>Profile</h1>
            <p className={` ${companypro ? 'text-[#409BF5]' : 'text-gray-500' }  cursor-pointer py-1 text-lg`} onClick={()=> {setCourtbook(false) ; setCompanypro(true) ; setManagecourt(false) ; setPayment (false) ; setNotifi (false) ; } } > Company Profile  </p>
            <p className={`  ${courtbook ? 'text-[#409BF5]' : 'text-gray-500' }  cursor-pointer py-1 text-lg `} onClick={()=> {setCourtbook(true) ; setCompanypro(false) ; setManagecourt(false) ; setPayment (false) ; setNotifi (false) ; } } > Court Booking  </p>
            <p className={`  ${managecourt ? 'text-[#409BF5]' : 'text-gray-500' }  cursor-pointer py-1 text-lg `} onClick={()=> {setCourtbook(false) ; setCompanypro(false) ; setManagecourt(true) ; setPayment (false) ; setNotifi (false) ; } } > Manage Courts  </p>
            <p className={`  ${payment ? 'text-[#409BF5]' : 'text-gray-500' }  cursor-pointer py-1 text-lg `} onClick={()=> {setCourtbook(false) ; setCompanypro(false) ; setManagecourt(false) ; setPayment (true) ; setNotifi (false) ; } } > Payment History </p>
            <p className={`  ${notifi ? 'text-[#409BF5]' : 'text-gray-500' }  cursor-pointer py-1 text-lg `} onClick={()=> {setCourtbook(false) ; setCompanypro(false) ; setManagecourt(false) ; setPayment (false) ; setNotifi (true) ; } } > Notifications  </p>
            </div>
            </div>

            <div className='md:w-[70%] mt-2 w-[95%] md:mx-1 mx-auto'>
           { companypro ?  <div className='profile-biz-company-profile '>
                 <BizCompanyPro/> 
             </div> : null} 

            { courtbook ? <div className='profile-biz-company-profile '>
                 <BizCourtBook/>  
             </div> : null}

             
            { managecourt ? <div className='profile-biz-company-profile  '>
                 <BizManageCourt/>    
             </div> : null}

             
             { payment ? <div className='profile-biz-company-profile  '>
                 <BizPaymentHis/>    
             </div> : null}

             { notifi ? <div className='profile-biz-company-profile '>
                 <BizNotifi/>    
             </div> : null}
            </div>








            </div>
            </div>



        </div>
      </div>  
    </>
  )
}

export default BizProfile